/**
 * Öffentliche Demo-Seite via Slug — z. B. signalslt.de/demo/salon-schmidt-berlin
 *
 * Lädt das vom Backend gerenderte HTML der Vorschau und ersetzt das gesamte Document.
 * Der Browser behält die schöne URL (statt zur Token-URL zu redirecten).
 */
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PublicDemoPage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || "index";
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    (async () => {
      try {
        const url = `${API}/api/public/demo/${encodeURIComponent(slug)}?page=${encodeURIComponent(page)}`;
        const res = await fetch(url, { credentials: "omit" });
        if (cancelled) return;
        if (!res.ok) {
          if (res.status === 404) {
            setError("Diese Demo wurde deaktiviert oder existiert nicht.");
          } else {
            setError("Die Demo-Website konnte nicht geladen werden.");
          }
          return;
        }
        const html = await res.text();
        if (cancelled) return;
        // Komplettes Dokument durch Demo-HTML ersetzen — URL bleibt /demo/{slug}
        document.open();
        document.write(html);
        document.close();
      } catch (e) {
        if (!cancelled) setError("Verbindungsfehler beim Laden der Demo.");
      }
    })();
    return () => { cancelled = true; };
  }, [slug, page]);

  if (error) {
    return (
      <div style={{
        minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
        background: "#0a0a0a", color: "#fafafa", fontFamily: "-apple-system,BlinkMacSystemFont,sans-serif",
        padding: "2rem", textAlign: "center"
      }}>
        <div data-testid="demo-error">
          <h1 style={{ fontSize: "1.6rem", marginBottom: "0.6rem", fontWeight: 800 }}>Demo nicht verfügbar</h1>
          <p style={{ opacity: 0.7, fontSize: ".95rem", maxWidth: "30rem" }}>{error}</p>
          <a href="/" style={{ color: "#60a5fa", marginTop: "1.5rem", display: "inline-block", textDecoration: "underline" }}>
            Zur Startseite
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "#fafafa", color: "#71717a", fontFamily: "-apple-system,BlinkMacSystemFont,sans-serif",
    }} data-testid="demo-loading">
      <div style={{ display: "flex", alignItems: "center", gap: ".75rem" }}>
        <div style={{
          width: 18, height: 18, border: "2px solid #d4d4d8", borderTopColor: "#0a0a0a",
          borderRadius: "50%", animation: "spin 1s linear infinite",
        }} />
        <span style={{ fontSize: ".95rem", letterSpacing: ".01em" }}>Demo wird geladen …</span>
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
